// extracted by mini-css-extract-plugin
module.exports = {"settings":"styles__settings___X1cnh","settingsIcon":"styles__settingsIcon___3KpS0"};